import React, { Component } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import ko from "date-fns/locale/ko";

class DataPicker2 extends Component {
    componentDidUpdate(prevState) {
        if (this.props.day !== prevState.day) {
            this.setState({day: this.props.day})
        }
    }

    constructor(props) {
        super()
        let day = props.day
        
        this.state = {day: day}
    }

    render() {
        return(
            <ReactDatePicker
                closeOnScroll={true}
                selected={this.state.day}
                onChange={(date) => this.setState({day: date})}
                locale={ko}
                dateFormat="yyyy-MM-dd"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                id={this.props.id}
                className="text"
            />
        )
    }
}
export { DataPicker2 };